import { render, staticRenderFns } from "./ConfigurationIncidentTypesGrid.vue?vue&type=template&id=24d7fe52&"
import script from "./ConfigurationIncidentTypesGrid.vue?vue&type=script&lang=js&"
export * from "./ConfigurationIncidentTypesGrid.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports